<template>
  <div class="container-fluid" style="margin-top:30px">
    <div v-if="onecategory.length > 2">
      <div class="m-6 p-4">
        <h3 class="category-name text-sm-left text-center">
          <router-link class="remove-atag" :to="'/cat/' + onecategory[1]">
            {{ onecategory[0] }}
            <span
              class="pull-right"
              style="font-size:20px; font-weight:bold; color:#000; margin-top:15px"
              >See more <i class="fa fa-caret-right"></i
            ></span>
          </router-link>
        </h3>
      </div>
      <div class="category-list">
        <span style="opacity:0">....</span>
        <carousel
          :perPage="1"
          :navigationEnabled="true"
          :paginationEnabled="false"
          :perPageCustom="[[768, 1], [1024, 5]]"
          class="VueCarousel"
          >&nbsp;
          <slide
            v-for="order in removenamenid(onecategory, 2)"
            :key="order.id"
            class="col-md-3 col-sm-4 col-xs-6 p-1 product-box"
          >
            <!-- <div class="card product-images" style="position:relative">
              <img
                class="card-img-top mt-3"
                style="height: 200px; width: 200px;"
                :src="getProduct(order.productsId, 'image')"
                alt=""
              />
            </div> -->
            <!-- Lazy -->
            <div
              v-lazy-container="{ selector: 'img' }"
              class="card product-images"
              style="position:relative"
            >
              <img
                :data-src="getProduct(order.productsId, 'image')"
                style="height: 200px; width: 200px;"
              />
              <div class="textx">
                <span class="insidetextx">₹ {{ order.sellPrice }} /-</span>
              </div>
            </div>

            <div class="product-other text-center">
              <h3 class="name">
                {{ getProduct(order.productsId, "name") }}
              </h3>
              <!-- Buttons -->
              <span
                class="cart-add"
                v-if="
                  order.stock > 1 && getCart(order.id, 'qty', getDataCart) > 0
                "
              >
                <i
                  class="btn btn-sm btn-circle fa fa-minus"
                  style="background-color:#D0D0D2; color:#1A1824;"
                  @click="
                    addToCart(
                      order.id,
                      order.productsId,
                      getCart(order.id, 'qty', getDataCart),
                      getProduct(order.productsId, 'unitType'),
                      order.sellPrice,
                      'minus',
                      user.uid,
                      order.vendorId
                    )
                  "
                  v-if="user"
                ></i>
                <span v-else>
                  <router-link to="/login">
                    <i
                      class="btn btn-sm btn-circle fa fa-minus"
                      style="background-color:#D0D0D2; color:#1A1824
                  "
                    ></i>
                  </router-link>
                </span>
                <span style="padding:5px;">
                  {{ getCart(order.id, "qty", getDataCart) }}
                  {{ getProduct(order.productsId, "unitType") }}
                </span>
                <i
                  class="btn btn-sm btn-circle fa fa-plus"
                  style="background-color:#51381b ; color:#FFFFFF;"
                  v-if="user"
                  @click="
                    addToCart(
                      order.id,
                      order.productsId,
                      getCart(order.id, 'qty', getDataCart),
                      getProduct(order.productsId, 'unitType'),
                      order.sellPrice,
                      'plus',
                      user.uid,
                      order.vendorId
                    )
                  "
                ></i>
                <span v-else>
                  <router-link to="/login">
                    <i
                      class="btn btn-sm btn-circle fa fa-plus"
                      style="background-color:#51381b ; color:#FFFFFF;"
                    ></i>
                  </router-link>
                </span>
              </span>
              <!--  -->
              <br />
              <div style="margin-top: -10.5%">
                <span
                  class="cart-add"
                  v-if="
                    order.stock > 1 && getCart(order.id, 'qty', getDataCart) < 1
                  "
                >
                  <button
                    class=""
                    style="background-color:#F69325 ; color:white; border:none; border-radius:20px; padding: 1px 20px; font-size:12px"
                    v-if="user"
                    @click="
                      addToCart(
                        order.id,
                        order.productsId,
                        getCart(order.id, 'qty', getDataCart),
                        getProduct(order.productsId, 'unitType'),
                        order.sellPrice,
                        'plus',
                        user.uid,
                        order.vendorId
                      )
                    "
                  >
                    Add to cart
                  </button>
                  <span v-else>
                    <router-link to="/login">
                      <button
                        class=""
                        style="background-color:#F69325 ; color:white;; border:none; border-radius:20px; padding: 1px 20px; margin-top:8px; font-size:12px"
                      >
                        Add to cart
                      </button>
                    </router-link>
                  </span>
                </span>
              </div>
              <span v-if="order.stock < 1">
                <h3 style="font-size:16px" class="text-danger">
                  Out of Stock
                </h3>
              </span>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dbFs } from "@/modules/database";
import { Carousel, Slide } from "vue-carousel";
import { getCart, addToCart } from "@/modules/cart";

export default {
  props: ["onecategory", "productimageandname"],
  components: {
    Carousel,
    Slide
  },
  data: () => {
    return {
      allcategory: []
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      getDataCart: "getDataCart"
    })
  },
  mounted() {
    this.getcategory();
  },
  methods: {
    getcategory() {
      this.$bind("allcategory", dbFs.collection("productCategory")).then(
        () => {}
      );
    },
    removenamenid(category, inx) {
      return category.slice(inx);
    },
    getProduct(id, dataType) {
      let productDetails = "";
      for (const cusKey of Object.keys(this.productimageandname)) {
        const product = this.productimageandname[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getCart,
    addToCart
  }
};
</script>

<style scoped>
.textx {
  float: right;
  width: 100%;
  text-align: right;
  position: absolute;
  color: white;
}
.insidetextx {
  font-weight: bold;
  background-color: black;
  padding: 0px 10px 5px 20px;
  font-size: 20px;
  border: 2px solid black;
  border-radius: 0px 0px 0px 30px;
}

@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");
.VueCarousel {
  display: flex;
  flex-direction: column;
  position: relative;
}
.remove-atag {
  text-decoration: none;
  color: #51381b;
}
.slide-bar-view {
  margin-left: 130px;
  margin-right: 130px;
}
.add-to-cart {
  padding-top: 15px;
}
.add-to-cart button {
  width: 120px;
  height: 42px;
  border-radius: 33px;
}
.cart-add {
  font-size: 1em;
  color: #000000;
}
.product-other .name {
  height: 30px;
  font-size: 1em;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}
.product-other .price {
  font-size: 1em;
  height: 20px;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 1.2px;
  color: #51381b;
}
.product-other {
  padding-top: 1em;
}
.product-images {
  height: 233px;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 0px;
}
.product-images img {
  margin: auto;
}
.product-box {
  border-radius: 0px !important;
  width: 215px;
  height: 400px;
}
.btn-for-box {
  width: 100%;
  height: 100%;
  max-width: 257px;
  max-height: 85px;
  background-color: #1c1a1a;
  opacity: 0.8;
  border-radius: 33px;
  backdrop-filter: blur(9px);
  margin: auto;
}
.btn-for-box h4 {
  font-size: 1.5em;
  font-family: "Pacifico", cursive;
  color: #ffffff;
  letter-spacing: 2.88px;
  padding-top: 15px;
  text-align: center;
}
.btn-for-box p {
  font-size: 1em;
  font-family: "Montserrat-Regular";
  color: #ffffff;
  letter-spacing: 0.51px;
  /* padding-top: 5px; */
  text-align: center;
}
.category-wise-item {
  margin-left: 50px;
  margin-right: 50px;
}
.category-wise-item .category-name {
  font-size: 34px;
  color: #313131;
  font-weight: bold;
}
.category-list {
  margin-left: 5px;
  margin-right: 5px;
}
.categoryImage {
  width: 376px;
  height: 242px;
}
.category {
  padding-left: 15px;
  padding-right: 15px;
}
.category-box-1 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/1.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-2 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/2.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-3 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/3.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-4 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/4.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-inside:hover {
  background-color: #51381b;
  opacity: 0.9;
  margin: auto;
}
.category-box-inside {
  height: 100%;
  margin: 0 auto;
  width: 100%;
  padding-top: 30%;
}
.primary-color {
  color: #17aa18;
}
@media only screen and (max-width: 1068px) {
  .media-query {
    display: none;
    background-color: #ffffff !important;
  }
}
</style>
